import { Component } from '@angular/core';
import { InterviewIndexTable } from '@app/modules/applicant-tracker/services';
import { RecruitingModuleMenuService } from '@app/modules/applicant-tracker/services/menus/recruiting-module-menu.service';

@Component({
    templateUrl: './interviews-index.template.html',
    styleUrls: ['./interviews-index.style.scss'],
})
export class InterviewsIndexView {
    isLoading = false;

    constructor(
        public interviewIndexTable: InterviewIndexTable,
        public recruitingModuleMenuService: RecruitingModuleMenuService
    ) {
        this.interviewIndexTable.reload();
    }
}
